import ODEButton from "@/components/global/Button/Button.vue";

export default {
    name : "OurServeces" ,
    components : {
        ODEButton
    }
}